import { render, staticRenderFns } from "./SuppliesNewModal.vue?vue&type=template&id=213b253d&"
import script from "./SuppliesNewModal.vue?vue&type=script&lang=js&"
export * from "./SuppliesNewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports